import React from "react";
import { RadioProps } from "antd/lib/radio";

import { StyledRadioButton } from "./radio-button.style";

import "./radio-button.less";

export const RadioButton: React.FC<RadioProps> = (props) => <StyledRadioButton {...props} />;
